import React from 'react';
type OptimizedImageProps = {
  src: string;
  alt: string;
  width: number;
  height: number;
  priority?: boolean;
  className?: string;
};

/**
 * Images below the fold load lazily and decode off the main thread.
 * Explicit width/height reserve space so the layout never jumps while loading.
 * Only the first visible image (priority) is fetched eagerly with high priority.
 */
export function OptimizedImage({
  src,
  alt,
  width,
  height,
  priority = false,
  className = ''
}: OptimizedImageProps) {
  const priorityAttrs = priority ? {
    fetchpriority: 'high'
  } as Record<string, string> : {};
  return <img src={src} alt={alt} width={width} height={height} loading={priority ? 'eager' : 'lazy'} decoding="async" className={className} {...priorityAttrs} data-id="element-128" data-mp="27tfcjyibvnqu" />;
}